/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type IconXSmall12Envelope2IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function IconXSmall12Envelope2Icon(
  props: IconXSmall12Envelope2IconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 12 12"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M6.718 7.817a1.5 1.5 0 0 1-1.437 0L0 4.936V9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.936z"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M6 6.5a.5.5 0 0 1-.239-.061l-5.5-3A.5.5 0 0 1 0 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2 .5.5 0 0 1-.26.439l-5.5 3A.5.5 0 0 1 6 6.5"
        }
      ></path>
    </svg>
  );
}

export default IconXSmall12Envelope2Icon;
/* prettier-ignore-end */
